import OriginalPaperContactChips from 'ember-paper/components/paper-contact-chips/component';
import { tagName } from '@ember-decorators/component';

@tagName('')
class PaperContactChips extends OriginalPaperContactChips {}

export default PaperContactChips;
